import React from "react";
import { useTranslation } from "react-i18next";

import { generateRaporURL } from "../../utils/generateRaporURL";

function ButtonRaporTK({
  tahun,
  semester,
  kelas,
  kelas_detail,
  user_id,
  sekolah,
  status,
}) {
  const URL_PORTO = generateRaporURL(
    "porto_tk",
    tahun,
    semester,
    kelas,
    kelas_detail,
    user_id,
    sekolah,
    true
  );
  const URL_RAPOR = generateRaporURL(
    "akhir_tk",
    tahun,
    semester,
    kelas,
    kelas_detail,
    user_id,
    sekolah,
    true
  );
  const { t } = useTranslation();
  if (status === "Tidak") {
    return (
      <div className="d-flex gap-1">
        <button className="btn btn-primary btn-sm" disabled>
          <i className="ri-printer-line"></i>
          {t("portofolio")}
        </button>
        <button className="btn btn-primary btn-sm" disabled>
          <i className="ri-printer-line"></i>
          {t("rapor_akhir")}
        </button>
      </div>
    );
  }
  return (
    <div className="d-flex gap-1">
      <a
        href={URL_PORTO}
        className="btn btn-primary btn-sm"
        target="_blank"
        rel="noreferrer"
      >
        <i className="ri-printer-line"></i>
        {t("portofolio")}
      </a>
      <a
        href={URL_RAPOR}
        className="btn btn-primary btn-sm"
        target="_blank"
        rel="noreferrer"
      >
        <i className="ri-printer-line"></i>
        {t("rapor_akhir")}
      </a>
    </div>
  );
}

export default ButtonRaporTK;
